export const WIZARD_PAGE_SIZE = 4;